import { styled } from "@mui/material/styles";

const StyledPasswordPolicy = styled("div")`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StyledPasswordPolicyItem = styled("div")`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledPasswordPolicyIconContainer = styled("div")`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 100%;
  }
`;

export {
  StyledPasswordPolicy,
  StyledPasswordPolicyItem,
  StyledPasswordPolicyIconContainer,
};
